import { render, staticRenderFns } from "./systemNewsDetail-dialog.vue?vue&type=template&id=44cb3fd4&scoped=true"
import script from "./systemNewsDetail-dialog.vue?vue&type=script&lang=js"
export * from "./systemNewsDetail-dialog.vue?vue&type=script&lang=js"
import style0 from "./systemNewsDetail-dialog.vue?vue&type=style&index=0&id=44cb3fd4&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb3fd4",
  null
  
)

export default component.exports